<template>
  <div
    class="country-card card-condition connection-type"
    :class="{
      noteq: value === 'IS_NOT_EMPTY',
      'card-condition__planLimits': hasPlanLimitsRestriction('externalIdCondition'),
    }"
  >
    <ui-tooltip-icon
      v-if="hasPlanLimitsRestriction('externalIdCondition')"
      class="card-condition__planLimits--tooltip"
      preset="error"
      :text="t('This option is no longer active due to the subscription change to the plan which doesn’t include this option or this add-on is switched off in your subscriptions settings.')"
    />
    <ui-icon @click="emit('close')" size="12" icon="fas fa-times" class="card-condition__close" />
    <ui-radio-group style-type="inline" v-model="value" :label="t('External ID')">
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="IS_EMPTY" :label="t('Is Empty')" />
        <ui-radio class="ml-16" value="IS_NOT_EMPTY" :label="t('Is Not Empty')" />
      </div>
    </ui-radio-group>
  </div>
</template>

<script setup lang="ts">
import { useFlowSingleValueCondition } from './useFlowSingleValueCondition';

const props = defineProps<{
  conditions: Record<string, { predicate: string; values: string }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, value, hasPlanLimitsRestriction } = useFlowSingleValueCondition(props.conditions, {
  conditionKey: 'externalId',
  defaultValue: 'IS_NOT_EMPTY',
  planLimitsKey: 'externalIdCondition',
});
</script>
